import { LoaderCircle } from 'lucide-react';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../lib/utils.js';

export function Spinner({
  className,
  label = 'Cargando',
  ...props
}: ComponentProps<'span'> & {
  label?: string;
}) {
  return (
    <span role="status" aria-label={label} className={cn('inline-flex', className)} {...props}>
      <LoaderCircle aria-hidden className="size-4 animate-spin text-muted-foreground" />
    </span>
  );
}

export interface EmptyStateProps {
  readonly icon?: ReactNode;
  readonly title: string;
  readonly description?: ReactNode;
  readonly action?: ReactNode;
  readonly tone?: 'neutral' | 'error';
  readonly className?: string;
}

/** Estado vacio / informativo con icono, titulo, descripcion y accion opcional. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  tone = 'neutral',
  className,
}: EmptyStateProps) {
  return (
    <div
      role={tone === 'error' ? 'alert' : undefined}
      className={cn(
        'flex h-full flex-col items-center justify-center gap-2 p-6 text-center',
        className,
      )}
    >
      {icon !== undefined && (
        <div
          className={cn(
            'mb-1 flex size-10 items-center justify-center rounded-full [&_svg]:size-5',
            tone === 'error'
              ? 'bg-destructive/10 text-destructive'
              : 'bg-muted text-muted-foreground',
          )}
        >
          {icon}
        </div>
      )}
      <p className="text-sm font-medium">{title}</p>
      {description !== undefined && (
        <div className="max-w-sm text-xs text-muted-foreground">{description}</div>
      )}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  );
}
